import React from 'react';

import { COLOR_BLUE, COLOR_TEAL } from '../../theme';

import type { WatchlistMatchMode } from '../../types';

const POLYGON = '88,12 20,22 8,60 40,88 100,80 112,34';

const POINTS: Record<WatchlistMatchMode, { a: [number, number], b: [number, number], label: string }> = {
    within: { a: [40, 62], b: [86, 36], label: 'Upphämtning A och leverans B ligger båda i området' },
    touches: { a: [48, 58], b: [150, 26], label: 'Upphämtning A ligger i området, leverans B utanför' }
};

type PointProps = { x: number, y: number, label: string };

function Point({ x, y, label }: PointProps) {
    return (
        <g>
            <circle cx={x} cy={y} r={8} fill="#fff" stroke={COLOR_BLUE} strokeWidth={1.5} />
            <text x={x} y={y + 3.5} textAnchor="middle" fontSize={10} fontWeight={700} fill={COLOR_BLUE}>
                {label}
            </text>
        </g>
    );
}

/** Static picture of a match scenario: the area and a mission from A (upphämtning) to B (leverans). */
export default function MatchModeIllustration({ mode }: { mode: WatchlistMatchMode }) {
    const { a, b, label } = POINTS[mode];
    return (
        <svg viewBox="0 0 170 96" width="100%" role="img" aria-label={label} style={{ display: 'block' }}>
            <polygon
                points={POLYGON}
                fill={COLOR_TEAL}
                fillOpacity={0.14}
                stroke={COLOR_TEAL}
                strokeWidth={1.5}
                strokeLinejoin="round"
            />
            <text x={30} y={40} fontSize={9} fill={COLOR_TEAL}>Området</text>
            <line
                x1={a[0]}
                y1={a[1]}
                x2={b[0]}
                y2={b[1]}
                stroke={COLOR_BLUE}
                strokeWidth={1.5}
                strokeDasharray="4 3"
            />
            <Point x={a[0]} y={a[1]} label="A" />
            <Point x={b[0]} y={b[1]} label="B" />
        </svg>
    );
}
